import { combineReducers } from 'redux';
import gradebook from './gradebook.reducer';

const gradebookAppReducer = combineReducers({
    gradebook,
});

export default gradebookAppReducer;


// WEBPACK FOOTER //
// src/main/content/gradebook/store/reducers/index.js